import MultiselectNestedDropdown from "@app/shared/checkbox-dropdown/MultiselectNestedDropdown";
import { NestingParentDropdownItem } from "@app/shared/checkbox-dropdown/types";
import { JSX } from "react";

interface NetworkIntegritySpecialtyFilterProps {
  disabled?: boolean;
  items: NestingParentDropdownItem[];
  selectedItems: string[];
  selectionText: string;
  onSelectionChanged: (selectedItems: string[]) => void;
}

const NetworkIntegritySpecialtyFilter = (props: NetworkIntegritySpecialtyFilterProps): JSX.Element => {
  const { disabled, items, selectedItems, selectionText, onSelectionChanged } = props;

  return (
    <MultiselectNestedDropdown
      containerClassName="item-column"
      customSelectInputText={selectionText}
      disabled={disabled}
      items={items}
      label="Specialty:"
      onSelectionChanged={onSelectionChanged}
      selectedItems={selectedItems}
      testId="network-integrity-filters__specialty"
    />
  );
};

export default NetworkIntegritySpecialtyFilter;
